import React from 'react';
import { Button, Form, SizeFittingTable } from 'src/components/Antd';
import css from './css.module.less';
// import Search from '@/src/components/Antd/Search/Search';
// import { SearchOutlined } from '@ant-design/icons';
import BulkEditor from '@/src/components/BulkEditor/BulkEditor';
import { useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { Icon } from '@/src/tools/icon';
import { EyeOutlined } from '@ant-design/icons';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { generalSort } from 'src/tools/helper';
import { EnumTablePosition } from 'src/types/common/common';

import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';

const ProductPart = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid: salesChannelUuid }: any = useParams();

  return (
    <SectionWrapper
      title={getI18n('salesChannelPromotionTag.index.linkedProduct')}
      containerClassName={css.container}>
      <Form.Item
        name='linkedProducts'
        rules={[
          {
            validator: async (x, value) => {
              if ((value || []).length < 1) {
                return Promise.reject(
                  new Error(
                    getI18n(
                      'salesChannelPromotionTag.index.pleaseSelectatleastoneitem',
                    ),
                  ),
                );
              }
            },
          },
        ]}>
        <ProductTable
          salesChannelUuid={salesChannelUuid}
          tableId={'SalesChannelPromotionTagTable'}
        />
      </Form.Item>
    </SectionWrapper>
  );
};

const ProductTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const h = useHistory();
  const { value, onChange, id, tableId, salesChannelUuid } = props;
  const [products, setProducts] = React.useState(value || []);
  //const isNoData = (products || []).length === 0;
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (value && value !== products) {
      setProducts(value || []);
    }
  }, [value]);

  const processProduct = React.useMemo(() => {
    return products.map((i) => {
      return { ...i, children: null };
    });
  }, [products]);

  const handleOnCancel = () => {
    setVisible(false);
  };

  const handleOnChange = (products) => {
    if (onChange) {
      onChange(products);
    }
    // setProducts(products);
  };

  const handleOnOk = (products) => {
    const _p = products;
    setProducts(_p);
    handleOnChange(_p);
    handleOnCancel();
  };

  const handleOnDelete = (record, index) => {
    const { uuid } = record;
    const p = products.filter((i) => {
      return i.uuid !== uuid;
    });
    setProducts(p);
    handleOnChange(p);
  };

  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    // setMappedSelectedKeys,
    // //mappedSelectedKeys,
    // setSelectedRowKeys,
  } = useSelectRows(products);

  const selectAll = () => {
    //TODO:选择全部待确认，是否需要从后端拿到全部的uuid
    const allSelect = products.map((item) => {
      return item.uuid;
    });
    if (setSelectedAll) setSelectedAll(true);
    rowSelection.onChange(allSelect);
  };

  const buttonMenu = [
    //Bulk Edit
    {
      key: '1',
      value: getI18n('general.remove'),
      function: () => {
        //console.log('selectedRowKeys', selectedRowKeys);
        // const { uuid } = record;
        const p = products.filter((i) => {
          return !selectedRowKeys.includes(i.uuid);
        });
        setProducts(p);
        handleOnChange(p);
      },
    },
  ];

  const col = (onDelete) => {
    return [
      {
        title: getI18n('general.productName'),
        dataIndex: 'productName',
        default: true,
        sorter: (a, b) => {
          const name1 = a.productName || '';
          const name2 = b.productName || '';
          return generalSort(name1, name2);
        },

        // className: css.expandRow,
        key: 'productName',
        childGenerate: (text, record) => {
          // console.log('record', record);
          const { productName } = record;
          return (
            <NoWrapContainer>
              <GlobalTooltip title={productName || '-'}>
                {productName || '-'}
              </GlobalTooltip>
            </NoWrapContainer>
          );
        },
        minWidth: 120,
      },
      {
        title: getI18n('general.sKU'),
        dataIndex: 'sku',
        sorter: (a, b) => {
          const name1 = a.sku || '';
          const name2 = b.sku || '';
          return generalSort(name1, name2);
        },
        default: true,
        key: 'sku',
        minWidth: 120,
        childGenerate: (text, record) => {
          return (
            <NoWrapContainer>
              <GlobalTooltip title={text || '-'}>{text || '-'}</GlobalTooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        title: getI18n('general.remarks'),
        dataIndex: 'remarks',
        default: true,
        key: 'remarks',
        sorter: (a, b) => {
          const name1 = a.remarks || '';
          const name2 = b.remarks || '';
          return generalSort(name1, name2);
        },
        minWidth: 90,
        childGenerate: (text, record) => {
          return (
            <NoWrapContainer>
              <GlobalTooltip title={text || '-'}>{text || '-'}</GlobalTooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        sorter: (a, b) => {
          const n1 = a.alias || '';
          const n2 = b.alias || '';

          if (n1 > n2) return 1;
          if (n2 > n1) return -1;
          return 0;
        },
        title: getI18n('general.alias'),
        default: true,
        key: 'alias',
        fixedWidth: 72,
        childGenerate: (a, record) => {
          const { alias, child } = record;
          return (
            <span>{child ? '' : alias ? getI18n('general.alias') : '-'}</span>
          );
        },
      },
      {
        sorter: (a, b) => {
          const n1 = a.visible || '';
          const n2 = b.visible || '';

          if (n1 > n2) return 1;
          if (n2 > n1) return -1;
          return 0;
        },
        title: getI18n('general.visibility'),
        default: true,
        key: 'Visibility',
        align: 'center',
        fixedWidth: 100,
        childGenerate: (a, record) => {
          const { visible } = record;
          return (
            <div className={css.icon}>
              {visible ? (
                <EyeOutlined className={css.eye} />
              ) : (
                <Icon type={'iconinvisible'} />
              )}
            </div>
          );
        },
      },
      {
        titleGenerate: () =>
          getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
        position: EnumTablePosition.mid,
        key: 'Actions',
        default: true,
        childGenerate: (url, record, index) => {
          const { uuid } = record;
          return (
            <Actions
              editText={getI18n('general.view')}
              onEdit={() => {
                h.push(
                  `/salesChannel/products/link/${salesChannelUuid}/${uuid}`,
                );
              }}
              onDelete={() => {
                if (onDelete) {
                  onDelete(record, index);
                }
              }}
            />
          );
        },
        fixedWidth: 128,
      },
    ];
  };

  return (
    <div className={css.productTableContainer} id={id}>
      {visible && (
        <ProductSelection
          //uniqueSku
          //canSelectChildren
          selectedProducts={products}
          onCancel={handleOnCancel}
          visible={visible}
          salesChannelUuid={salesChannelUuid}
          onOk={handleOnOk}
        />
      )}
      <div className={css.bulkContainer}>
        <BulkEditor
          selectAll={selectAll}
          selectedAll={selectedAll}
          buttonMenu={buttonMenu}
          total={(products || []).length}
          dataSource={products}
          selectedRowKeys={selectedRowKeys} //mappedSelectedKeys}
          //allSelected={mappedSelectedKeys}
        />
        <Button
          type='primary'
          onClick={() => {
            setVisible(true);
          }}>
          {getI18n('general.addProduct')}
        </Button>
      </div>

      <SizeFittingTable
        showSorterTooltip={false}
        rowSelection={rowSelection}
        id={tableId || 'SalesChannelPromotionTagTable' + id}
        dataSource={processProduct}
        pagination={false}
        columns={col(handleOnDelete)}
        rowKey={'uuid'}
        scroll={{ x: 'max-content', y: 600 }}
      />
    </div>
  );
};

export default ProductPart;
